import { type PropsWithChildren } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import type {
  ColorPalette,
  CustomColorPalette,
} from '../../core/types/color-palette.js';
import { SankeyColorPaletteContext } from '../context/SankeyColorPalette.context.js';
import { SankeyColumnLabelsContext } from '../context/SankeyColumnLabels.context.js';
import { SankeyNodesContext } from '../context/SankeyNodes.context.js';
import { SankeyTruncationModeContext } from '../context/SankeyTruncationMode.context.js';
import type { SankeyChartNodesProps } from '../types/sankey-props.js';

interface SankeyConfigProviderProps {
  nodesConfig: SankeyChartNodesProps;
  truncationMode: TruncationMode;
  colorPalette: ColorPalette | CustomColorPalette;
  columnLabels: Record<number, string> | undefined;
}

export const SankeyConfigProvider = ({
  nodesConfig,
  truncationMode,
  colorPalette,
  columnLabels,
  children,
}: PropsWithChildren<SankeyConfigProviderProps>) => (
  <SankeyTruncationModeContext.Provider value={truncationMode}>
    <SankeyColorPaletteContext.Provider value={colorPalette}>
      <SankeyColumnLabelsContext.Provider value={columnLabels}>
        <SankeyNodesContext.Provider value={nodesConfig}>
          {children}
        </SankeyNodesContext.Provider>
      </SankeyColumnLabelsContext.Provider>
    </SankeyColorPaletteContext.Provider>
  </SankeyTruncationModeContext.Provider>
);

SankeyConfigProvider.displayName = 'SankeyConfigProvider';
